module.exports = __webpack_public_path__ + "img/网站3-40.972dcd02.png";